import styled from '@emotion/styled';
import { Button } from 'antd';

export const AddLoanButton = styled(Button)`
  border-radius: 4px;
  border: 1px solid ${props => props.theme.color.primary};
  color: ${props => props.theme.color.primary};
  height: 100%;
  width: 100%;
`;
